export default {
  modelName: 'alliance',
  label: '聯盟',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '名稱',
          rules: 'required',
          maxlength: 100,
        },
        description: {
          type: 'textarea',
          label: '描述',
          maxlength: 1000,
        },
      },
    },
    name: {
      type: 'text',
      label: '名稱',
      rules: 'required',
      maxlength: 100,
    },
    area: {
      type: 'belongsTo',
      label: '地區',
      rules: 'required',
      textKey: 'name',
      modelName: 'area',
      clearable: true,
    },
    remark: {
      type: 'textarea',
      label: '備註',
      maxlength: 1000,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
    logo: {
      type: 'file',
      label: 'logo',
      uploadUrl: '/alliance/logo/',
    },
    related_modules: {
      type: 'multi-select',
      label: '相關模組',
      multiple: true,
      items: [
        {
          text: '新訊',
          value: 'announcement',
        },
        {
          text: '法規',
          value: 'act',
        },
      ],
    },
  },
};
